import { render, staticRenderFns } from "./template.app.vue?vue&type=template&id=826ae028&"
import script from "./template.app.vue?vue&type=script&lang=js&"
export * from "./template.app.vue?vue&type=script&lang=js&"
import style0 from "./template.app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports